import React, { useState } from 'react';

const RiskAssessment = () => {
    const [industry, setIndustry] = useState('Technology & IT');
    const [employees, setEmployees] = useState('1-10');
    const [handlesData, setHandlesData] = useState(null);
    const [tradesGoods, setTradesGoods] = useState(null);
    const [riskProfileResult, setRiskProfileResult] = useState(null);

    const generateRiskProfile = (e) => {
        e.preventDefault();

        if (handlesData === null || tradesGoods === null) {
            setRiskProfileResult('<p class="text-red-400">Please answer all questions.</p>');
            return;
        }

        let recommendations = new Set();
        recommendations.add('Property Insurance');
        recommendations.add('General Liability');

        if (employees !== '1-10') {
            recommendations.add('Employee Benefits');
        }
        if (handlesData === 'yes') {
            recommendations.add('Cyber Liability Insurance');
        }
        if (tradesGoods === 'yes') {
            recommendations.add('Marine & Cargo Insurance');
        }
        if (industry === 'Professional Services (Consulting, Legal, etc.)') {
            recommendations.add('Professional Indemnity');
        }

        let resultHTML = '<h4 class="font-bold text-lg mb-4 text-white">Based on your answers, we recommend considering:</h4>';
        resultHTML += '<ul class="list-disc list-inside text-left max-w-md mx-auto text-sky-300">';
        recommendations.forEach(rec => {
            resultHTML += `<li>${rec}</li>`;
        });
        resultHTML += '</ul>';
        resultHTML += '<p class="mt-6 text-sm text-gray-400">This is a preliminary profile. Please schedule a full consultation for a detailed analysis.</p>';

        setRiskProfileResult(resultHTML);
    };

    return (
        <section id="risk-assessment" className="bg-gray-800 text-white py-20">
            <div className="container mx-auto px-6">
                <h2 className="text-3xl md:text-4xl font-serif-display text-center font-bold mb-12 section-title">Get a Smarter Perspective on Your Risk</h2>
                <div className="max-w-4xl mx-auto bg-gray-900 p-8 md:p-12 rounded-lg shadow-2xl">
                    <p className="text-center text-gray-300 mb-8">Answer a few questions and our system will generate a preliminary risk profile for your business, highlighting key areas for consideration.</p>
                    <form onSubmit={generateRiskProfile}>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                            <div>
                                <label htmlFor="industry" className="block mb-2 font-semibold">What industry is your business in?</label>
                                <select id="industry" className="w-full p-3 rounded-md bg-gray-700 border border-gray-600 focus:border-sky-500 focus:ring-sky-500" value={industry} onChange={(e) => setIndustry(e.target.value)}>
                                    <option>Technology & IT</option>
                                    <option>Manufacturing & Industrial</option>
                                    <option>Retail & E-commerce</option>
                                    <option>Professional Services (Consulting, Legal, etc.)</option>
                                    <option>Logistics & Transportation</option>
                                </select>
                            </div>
                            <div>
                                <label htmlFor="employees" className="block mb-2 font-semibold">How many employees do you have?</label>
                                <select id="employees" className="w-full p-3 rounded-md bg-gray-700 border border-gray-600 focus:border-sky-500 focus:ring-sky-500" value={employees} onChange={(e) => setEmployees(e.target.value)}>
                                    <option>1-10</option>
                                    <option>11-50</option>
                                    <option>51-200</option>
                                    <option>200+</option>
                                </select>
                            </div>
                            <div>
                                <label className="block mb-2 font-semibold">Do you handle sensitive customer data?</label>
                                <div className="flex space-x-4">
                                    <label><input type="radio" name="data" value="yes" className="mr-2" checked={handlesData === 'yes'} onChange={() => setHandlesData('yes')} /> Yes</label>
                                    <label><input type="radio" name="data" value="no" className="mr-2" checked={handlesData === 'no'} onChange={() => setHandlesData('no')} /> No</label>
                                </div>
                            </div>
                            <div>
                                <label className="block mb-2 font-semibold">Do you import or export goods?</label>
                                <div className="flex space-x-4">
                                    <label><input type="radio" name="trade" value="yes" className="mr-2" checked={tradesGoods === 'yes'} onChange={() => setTradesGoods('yes')} /> Yes</label>
                                    <label><input type="radio" name="trade" value="no" className="mr-2" checked={tradesGoods === 'no'} onChange={() => setTradesGoods('no')} /> No</label>
                                </div>
                            </div>
                        </div>
                        <div className="text-center">
                            <button type="submit" className="bg-sky-500 hover:bg-sky-600 text-white font-bold py-3 px-8 rounded-full text-lg transition duration-300">Generate My Risk Profile</button>
                        </div>
                    </form>
                    <div id="risk-profile-result" className={`mt-8 text-center p-6 bg-gray-700 rounded-lg ${riskProfileResult ? 'block' : 'hidden'}`} dangerouslySetInnerHTML={{ __html: riskProfileResult }}>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default RiskAssessment;
